/** @format */

import {Container, Box, Grid} from '@chakra-ui/react';
import Image from 'next/image';
import {ReactElement} from 'react';
import HeroText from '../HeroText';
import {HeroBannerPhotographicProps} from './HeroBannerPhotographicProps';

export function HeroBannerPhotographic1({
	image,
	hasBackground,
	backgroundColor,
	heroText,
}: HeroBannerPhotographicProps): ReactElement {
	if (!heroText) {
		return null;
	}

	const overlay = hasBackground
		? 'linear-gradient(90deg, rgba(10, 22, 39, 0.5) 0%, rgba(10, 22, 39, 0.5))'
		: 'none';

	return (
		<Box
			backgroundColor={backgroundColor || 'uisge.700'}
			as='section'
			overflow='hidden'
			position='relative'>
			{image && (
				<Box
					position={{base: 'relative', md: 'absolute'}}
					height={{base: '227px', md: '100%'}}
					top={{md: '0'}}
					left={{md: '0'}}
					right={{md: '0'}}
					bottom={{md: '0'}}>
					<Image
						src={image.src}
						alt={image.alt}
						layout='fill'
						objectFit='cover'
						objectPosition='center'
						priority
					/>
					{hasBackground && (
						<Box
							className='overlay-box'
							position='absolute'
							top='0'
							left='0'
							right='0'
							bottom='0'
							backgroundImage={overlay}
							backgroundSize='cover'
							backgroundPosition='center'
							backgroundRepeat='no-repeat'
							zIndex={{base: '-1', md: '0'}}></Box>
					)}
				</Box>
			)}
			<Container
				position='relative'
				maxW='container.xl'
				mx='auto'
				className='photographic-banner-container'>
				<Grid
					templateColumns={{base: '1fr', md: '3fr 1fr'}}
					columnGap='8'
					minHeight={{md: '302px'}}>
					<Box
						alignSelf={'center'}
						paddingTop={{base: '10', md: '20'}}
						paddingBottom={{base: '10', md: '20'}}>
						<HeroText
							// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
							heading={heroText.heading}
							supportingText={heroText.supportingText}
							variant={heroText.variant}
						/>
					</Box>
				</Grid>
			</Container>
		</Box>
	);
}
